import React, { useState, useEffect } from 'react';

const BlogTagsInput = ({ blogTags = [], handleTagsInput }) => {
  // blogTagsが配列であることを確認する
  const [tags, setTags] = useState(Array.isArray(blogTags) ? blogTags : []);

  useEffect(() => {
    if (Array.isArray(blogTags)) {
      setTags(blogTags);
    }
  }, [blogTags]); 

  useEffect(() => {
    // タグが変更された場合にhandleTagsInputで配列として親コンポーネントに通知
    handleTagsInput(tags);
  }, [tags]);

  const removeTag = indexToRemove => {
    const newTags = tags.filter((_, index) => index !== indexToRemove);
    setTags(newTags);
    handleTagsInput(newTags);
  };

  const addTag = e => {
    let newTag = '';
    // クリックされたタグの値が渡された場合
    if (typeof e === 'string') {
      newTag = e;
    } else if (e.target && e.target.value) {
      // 入力フォームからの値が渡された場合
      newTag = e.target.value.trim();
    }
    if (newTag !== '' && !tags.includes(newTag)) {
      const updatedTags = [...tags, newTag];
      setTags(updatedTags);
      handleTagsInput(updatedTags);  // 親コンポーネントに変更を通知

      if (e.target) {
        e.target.value = '';  
      }
    }
  };

  const onKeyDown = e => {
    if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
      addTag(e);
    }
  };
  
  return (
    <div className="tags-input mt-0">
      <ul id="tags">
        {tags.map((tag, index) => (
          <li key={index} className="btn btn-outline-primary btn-outline-blue btn-sm btn-sm--expand mr-2 d-inline-blockｓ">
            <span className="tag-title mr-1">{tag}</span>
            <span className="tag-close-icon" onClick={() => removeTag(index)}>
              ×
            </span>
          </li>
        ))}
      </ul>
      {tags.length < 20 && (
        <input
          type="text"
          onKeyDown={(e) => onKeyDown(e)}
          onBlur={addTag}
          placeholder="カテゴリを入力してください。"
        />
      )}
    </div>
  );
};

export default BlogTagsInput;
